/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} App_Slider_Upload_DocumentsInputs */

const en_app_slider_upload_documents = /** @type {(inputs: App_Slider_Upload_DocumentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload Documents.`)
};

const es_app_slider_upload_documents = /** @type {(inputs: App_Slider_Upload_DocumentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subir documentos.`)
};

/**
* | output |
* | --- |
* | "Upload Documents." |
*
* @param {App_Slider_Upload_DocumentsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const app_slider_upload_documents = /** @type {((inputs?: App_Slider_Upload_DocumentsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<App_Slider_Upload_DocumentsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_app_slider_upload_documents(inputs)
	return en_app_slider_upload_documents(inputs)
});